import {
  SET_USER_INFO,
  SET_MENU,
  SET_CALLBACK_QUERY,
  SET_HANDLE_MODAL,
  SET_COUNT_DOWN,
  SET_UNNOTICE_COUNT,
  SET_NOTICE_DETAIL,
  SET_BATCHSKU_LIST,
  SET_SHOW_LOADING,
  SET_EDITENQUIRE_DETAILS
} from './action'

export default function counter (state = {}, action) {
  switch (action.type) {
    case SET_USER_INFO:
      return Object.assign({}, state, action.data)
    case SET_MENU:
      return Object.assign([], state, action.data)
    case SET_CALLBACK_QUERY:
      return Object.assign({}, state, action.data)
    case SET_HANDLE_MODAL:
      return Object.assign({}, state, action.data)
    case SET_COUNT_DOWN:
      return Object.assign({}, state, action.data)
    case SET_UNNOTICE_COUNT:
      return Object.assign({}, state, action.data)
    case SET_NOTICE_DETAIL:
      return Object.assign({}, state, action.data)
    case SET_BATCHSKU_LIST:
      return Object.assign([], state, action.data)
    case SET_SHOW_LOADING:
      return Object.assign({}, state, action.data)
    case SET_EDITENQUIRE_DETAILS:
      return Object.assign({}, state, action.data)
    default:
      return state
  }
}
